import { FunctionComponent } from "react";
import CompletePasswordContainer from "../../../components/CompletePasswordContainer";

const CompletePasswordChange: FunctionComponent = ({}) => {
  return <CompletePasswordContainer />;
};

export default CompletePasswordChange;
